export const FacebookLogo = require('./facebook.svg');
export const InstagramLogo = require('./instagram.svg');
export const TwitterLogo = require('./twitterX.svg');
export const LinkedinLogo = require('./linkedin.svg');
export const TiktokLogo = require('./tiktok.svg');
